import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { TOOL_TYPE_LIST } from './tool-select-bar.data';
import { SafeHtmlPipe } from '../../pipe/safe-html.pipe';
import { CommonModule } from '@angular/common';
import { ThreedProject } from '../../services/project-controller/project-controller';
import { UserData, UserService } from 'src/app/core/user/user.service';

@Component({
  selector: 'tool-select-bar',
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './tool-select-bar.component.html',
  styleUrl: './tool-select-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolSelectBarComponent {
  public project: InputSignal<ThreedProject | undefined> = input();
  public isLoading: InputSignal<boolean> = input(false);
  public isNameHide: InputSignal<boolean> = input(false);
  public selectedTool: InputSignal<{ name: string; icon: string } | undefined> = input();
  public changeSelectedTool: OutputEmitterRef<
    { name: string; slug: string; icon: string } | undefined
  > = output<{ name: string; slug: string; icon: string } | undefined>();
  public userData: UserData | null = null;
  public toolTypeList: Array<{ name: string; slug: string; icon: string }> = TOOL_TYPE_LIST;

  constructor(private userService: UserService) {
    this.userData = this.userService.userData;
  }

  onClickTool(toolData: { name: string; slug: string; icon: string }): void {
    this.changeSelectedTool.emit(toolData);
  }
}
